import { render, staticRenderFns } from "./KeyboardShortcutModal.vue?vue&type=template&id=1be3842a&scoped=true&"
import script from "./KeyboardShortcutModal.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutModal.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcutModal.vue?vue&type=style&index=0&id=1be3842a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3842a",
  null
  
)

export default component.exports